import { gql } from '../../../core/graphql-client.js';
import { router } from '../../../core/router.js';
import type { Quarter } from '../../../types.js';

export class QuartersListPage extends HTMLElement {
  private quarters: Quarter[] = [];

  connectedCallback(): void {
    this.innerHTML = '<loading-spinner text="Ładowanie kwartałów..."></loading-spinner>';
    this.loadData();
  }

  private async loadData(): Promise<void> {
    try {
      const data = await gql.query<{ quarters: Quarter[] }>(`
        query { quarters { year quarterNum label isActive saturdays { date isSkipped } } }
      `);
      this.quarters = data.quarters;
      this.render();
    } catch (e) {
      this.innerHTML = `<div class="page"><p class="error-text">Błąd: ${e instanceof Error ? e.message : e}</p></div>`;
    }
  }

  private render(): void {
    this.innerHTML = `
      <div class="page">
        <div class="page-header">
          <h1>Kwartały</h1>
        </div>
        <p class="page-hint">Kwartały tworzone są automatycznie przy publikacji grafiku.</p>
        <div class="quarters-list">
          ${this.quarters.map(q => {
            const total = q.saturdays?.length ?? 0;
            const skipped = q.saturdays?.filter(s => s.isSkipped).length ?? 0;
            return `
            <div class="card quarter-card ${q.isActive ? 'quarter-active' : ''}" data-year="${q.year}" data-num="${q.quarterNum}">
              <div class="quarter-card-header">
                <span class="quarter-label">${q.label}</span>
                ${q.isActive ? '<span class="chip chip-success">Aktywny</span>' : ''}
              </div>
              <div class="quarter-card-meta">${total} sobót${skipped > 0 ? `, ${skipped} pominiętych` : ''}</div>
            </div>
          `}).join('')}
        </div>
      </div>
      <style>
        .page-hint { font-size: .875rem; color: var(--color-on-surface-muted); margin-bottom: var(--space-md); }
        .quarters-list { display: flex; flex-direction: column; gap: var(--space-sm); }
        .quarter-card { cursor: pointer; }
        .quarter-active { border-left: 3px solid var(--color-primary); }
        .quarter-card-header { display: flex; align-items: center; gap: var(--space-sm); }
        .quarter-label { font-size: 1.125rem; font-weight: 600; }
        .quarter-card-meta { font-size: .8rem; color: var(--color-on-surface-muted); margin-top: var(--space-xs); }
        .chip-success { background: var(--color-success-bg); color: var(--color-success); border-color: var(--color-success); }
        .error-text { color: var(--color-error); }
      </style>
    `;

    // Card click → edit saturdays
    this.querySelectorAll('.quarter-card').forEach(card => {
      card.addEventListener('click', () => {
        const el = card as HTMLElement;
        router.navigate(`/admin/quarters/${el.dataset.year}/${el.dataset.num}`);
      });
    });
  }
}

customElements.define('quarters-list-page', QuartersListPage);
